import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import helpers from '../../../../helpers/helpers';
import DropdownLayout from '../../../UI/DropdownLayout/DropdownLayout';
import TriggerBtn from '../../../UI/TriggerBtn/TriggerBtn';
import styles from './CategorySelect.module.scss';
import IconChevronDown from '../../../UI/Icons/IconChevronDown';
import CustomLink from '../../../UI/CustomLink';

function CategorySelect({slugs}) {
  const {
    categories,
  } = useSelector((state) => ({
    categories: state.categories.categoriesList,
  }));

  const [isOpen, toggleCategories] = useState(false);
  const [subCategory, setSubCategory] = useState([]);
  const [subSubCategory, setSubSubCategory] = useState([]);
  const [catTitle, setCatTitle] = useState('');
  const [categorySlug, setCategorySlug] = useState('');
  const [subCategorySlug, setSubCategorySlug] = useState('');

  const {getTranslationText, getCategory} = helpers;

  useEffect(() => {
    if (slugs?.length && categories?.data?.length) {
      const [categorySlug, subCategorySlug] = slugs;

      if (categorySlug) {
        const category = getCategory(categories.data, categorySlug);

        if (category) {
          setCatTitle(category.title);
          setCategorySlug(categorySlug);

          if (category.children.length) {
            setSubCategory(category.children);
          } else {
            setSubCategory([]);
          }
        }

        if (subCategorySlug && category) {
          setSubCategorySlug(subCategorySlug);

          if (category.children.length) {
            const subCategory = getCategory(category.children, subCategorySlug);

            if (subCategory && subCategory.children.length) {
              setSubSubCategory(subCategory.children);
            }
          } else {
            setSubSubCategory([]);
          }
        } else {
          setSubCategorySlug('');
        }
      }
    }
  }, [slugs, categories]);

  return (
    <DropdownLayout
      trigger={
        <TriggerBtn
          onClick={() => {
            toggleCategories(!isOpen)
          }}
          text={subCategory.length || subSubCategory.length ? catTitle : getTranslationText('general.categories')}
          icon={<IconChevronDown style={{transform: `rotate(${isOpen ? '180deg' : '0'})`}}/>}
        />}
      content={
        <div className={styles.categoriesList}>
          {categories.data?.map(cat => (
            <div className={styles.categorySection}>
              <CustomLink
                href="/category/[...slug]"
                as={`/category/${cat.slug.split('__')[0]}`}
                shallow
                className={styles.categoryLink}
              >
                <svg
                  viewBox="0 0 24 24"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{__html: cat.images}}
                />
                {cat.title}
              </CustomLink>
              {!!cat.children?.length && (
                <div className={styles.subcategorySection}>
                  {cat.children.map(subCat => (
                    <div>
                      <CustomLink
                        href="/category/[...slug]"
                        as={`/category/${cat.slug.split('__')[0]}/${subCat.slug.split('__')[0]}`}
                        shallow
                        className={styles.subcategoryLink}
                      >
                        {subCat.title}
                      </CustomLink>
                      {!!subCat.children?.length && (
                        <div className={styles.subSubcategorySection}>
                          {subCat.children.map(subSubCat => (
                            <CustomLink
                              href="/category/[...slug]"
                              as={`/category/${cat.slug.split('__')[0]}/${subCat.slug.split('__')[0]}/${subSubCat.slug.split('__')[0]}`}
                              shallow
                              className={styles.subSubcategoryLink}
                            >
                              {subSubCat.title}
                            </CustomLink>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      }
      isOpen={isOpen}
      onClose={() => toggleCategories(false)}
    />
  );
}

export default CategorySelect;
